import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { ProgressBar } from "primereact/progressbar";
import { getReportCard } from "../../api/examApi";
import { getChildren } from "../../api/parentDashboardApi";
import { getSessions } from "../../api/sessionApi";
import { useAuth } from "../../common/contexts/AuthContext";

const ReportCardView = () => {
  const { user } = useAuth();
  const roleName = user?.role?.name || user?.Role?.name;
  const isParent = roleName === "Parent";
  const [children, setChildren] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [studentId, setStudentId] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [report, setReport] = useState(null);

  useEffect(() => {
    if (isParent) {
      getChildren().then((data) => {
        if (data?.success) {
          setChildren(data.items || []);
          if (data.items?.[0]) setStudentId(data.items[0].id);
        }
      });
    }
    getSessions()
      .then((s) => setSessions(Array.isArray(s) ? s : s?.data || s?.items || []))
      .catch(() => {});
  }, [isParent]);

  useEffect(() => {
    if (!studentId) return;
    getReportCard({ studentId, sessionId })
      .then((data) => {
        if (data?.success) setReport(data);
      })
      .catch(() => setReport(null));
  }, [studentId, sessionId]);

  return (
    <Card>
      <h2>Report Card</h2>
      <div className="formgrid grid">
        {isParent && (
          <div className="field col-12 md:col-6">
            <label>Child</label>
            <Dropdown
              value={studentId}
              options={children}
              optionLabel="full_name"
              optionValue="id"
              onChange={(e) => setStudentId(e.value)}
              className="w-full"
              placeholder="Select child"
            />
          </div>
        )}
        {!isParent && (
          <div className="field col-12 md:col-6">
            <label>Student ID</label>
            <input
              type="number"
              value={studentId || ""}
              onChange={(e) => setStudentId(Number(e.target.value) || null)}
              className="p-inputtext w-full"
              placeholder="Enter student ID"
            />
          </div>
        )}
        <div className="field col-12 md:col-6">
          <label>Session</label>
          <Dropdown
            value={sessionId}
            options={sessions}
            optionLabel="name"
            optionValue="id"
            onChange={(e) => setSessionId(e.value)}
            className="w-full"
            placeholder="All sessions"
            showClear
          />
        </div>
      </div>

      {report?.subjects ? (
        <DataTable value={report.subjects} stripedRows emptyMessage="No results published yet.">
          <Column field="subject" header="Subject" />
          <Column field="totalMarks" header="Total Marks" />
          <Column field="obtainedMarks" header="Obtained" />
          <Column
            field="percentage"
            header="Percentage"
            body={(row) => (
              <div style={{ minWidth: 120 }}>
                <ProgressBar value={Math.round(row.percentage || 0)} showValue />
              </div>
            )}
          />
          <Column field="grade" header="Grade" />
        </DataTable>
      ) : (
        <p className="opacity-70">Select a student and session to view the report card.</p>
      )}
    </Card>
  );
};

export default ReportCardView;
